(() => {
    'use strict';



    const CONFIG = {
        initialWrittenReviews: 5,
        fallbackImage:
            'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 400 400"><rect width="400" height="400" fill="%23F3F4F6"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="%23014465" font-family="Arial" font-size="24">Review Photo</text></svg>',
        helpfulStorageKey: 'yaynuts-judgeme-helpful',
        apiToken: 'H9BVeyB65kywVWnPWkBQrG1_d_E',
        shopDomain: window.Shopify?.shop || 'yaynuts.myshopify.com',
        perPage: 50,
        maxPages: 20
    };


    const VERIFIED_STATUSES = new Set([
        'confirmed-buyer',
        'buyer',
        'verified-purchase',
        'semi-verified-purchase',
        'admin'
    ]);

    const state = {
        allReviews: [],
        reviews: [],
        mediaReviews: [],
        writtenVisibleCount: CONFIG.initialWrittenReviews,
        currentIndex: 0,
        helpful: loadHelpfulState()
    };

    const elements = {};

    document.addEventListener('DOMContentLoaded', init);

    function init() {
        cacheElements();

        if (!elements.gallery || !elements.modal || !elements.writtenReviewsList) {
            return;
        }

        bindStaticEvents();
        renderLoadingState();
        void loadReviews();
    }

    function cacheElements() {
        Object.assign(elements, {
            gallery: document.getElementById('gallery'),
            galleryPrev: document.getElementById('galleryPrev'),
            galleryNext: document.getElementById('galleryNext'),
            writtenReviewsList: document.getElementById('writtenReviewsList'),
            writtenReviewsShowMore: document.getElementById('writtenReviewsShowMore'),
            reviewsAverageRating: document.getElementById('reviewsAverageRating'),
            reviewsBasedOnText: document.getElementById('reviewsBasedOnText'),
            galleryReviewsCount: document.getElementById('galleryReviewsCount'),
            reviewsMetaCount: document.getElementById('reviewsMetaCount'),
            reviewSortSelect: document.getElementById('reviewSortSelect'),
            modal: document.getElementById('lightboxModal'),
            modalBackdrop: document.getElementById('modalBackdrop'),
            modalClose: document.getElementById('modalClose'),
            modalImage: document.getElementById('modalImage'),
            thumbStrip: document.getElementById('thumbStrip'),
            starRating: document.getElementById('starRating'),
            reviewerName: document.getElementById('reviewerName'),
            reviewerAvatar: document.getElementById('reviewerAvatar'),
            verifiedBadge: document.getElementById('reviewVerifiedBadge'),
            timeAgo: document.getElementById('timeAgo'),
            productVariant: document.getElementById('productVariant'),
            reviewText: document.getElementById('reviewText'),
            upCount: document.getElementById('upCount'),
            downCount: document.getElementById('downCount'),
            thumbUp: document.getElementById('thumbUp'),
            thumbDown: document.getElementById('thumbDown'),
            imgPrev: document.getElementById('imgPrev'),
            imgNext: document.getElementById('imgNext'),
            thumbPrev: document.getElementById('thumbPrev'),
            thumbNext: document.getElementById('thumbNext'),
            reviewsAverageStars: document.getElementById('reviewsAverageStars'),
            flavorRating: document.getElementById('reviewsFlavorRating'),
            valueRating: document.getElementById('reviewsValueRating')
        });
    }

    async function loadReviews() {
        try {
            const rawReviews = await fetchAllReviews();
            state.allReviews = transformReviews(rawReviews);

            // Generate summary based on all store reviews (or the sample if totals not provided)
            state.reviews = [...state.allReviews];
            renderSummary();

            // Apply default sort/filter (Photos & Videos is selected by default in HTML) —
            // but if none of the loaded reviews have extractable photos, that filter would
            // leave the whole section blank, so fall back to showing all reviews by recency.
            let defaultSort = elements.reviewSortSelect ? elements.reviewSortSelect.value : 'media';
            const hasMediaReviews = state.allReviews.some((review) => review.images.length > 0);
            if (defaultSort === 'media' && !hasMediaReviews) {
                defaultSort = 'recent';
                if (elements.reviewSortSelect) elements.reviewSortSelect.value = 'recent';
            }
            applySortFilter(defaultSort);
        } catch (error) {
            renderErrorState(error);
        }
    }

    function bindStaticEvents() {
        elements.galleryPrev?.addEventListener('click', () => scrollGallery(-1));
        elements.galleryNext?.addEventListener('click', () => scrollGallery(1));
        elements.writtenReviewsShowMore?.addEventListener('click', showMoreReviews);
        elements.reviewSortSelect?.addEventListener('change', (e) => applySortFilter(e.target.value));

        elements.modalBackdrop?.addEventListener('click', closeModal);
        elements.modalClose?.addEventListener('click', closeModal);
        elements.imgPrev?.addEventListener('click', prevImage);
        elements.imgNext?.addEventListener('click', nextImage);
        elements.thumbPrev?.addEventListener('click', prevImage);
        elements.thumbNext?.addEventListener('click', nextImage);
        elements.thumbUp?.addEventListener('click', () => updateHelpfulVote('up'));
        elements.thumbDown?.addEventListener('click', () => updateHelpfulVote('down'));

        document.addEventListener('keydown', handleDocumentKeydown);
        elements.modal?.addEventListener('keydown', trapModalFocus);

        elements.modalImage?.addEventListener(
            'touchstart',
            (event) => {
                elements.modalImage.dataset.touchStartX = String(event.changedTouches[0].screenX);
            },
            { passive: true }
        );

        elements.modalImage?.addEventListener(
            'touchend',
            (event) => {
                const touchStartX = Number(elements.modalImage.dataset.touchStartX || 0);
                const touchEndX = event.changedTouches[0].screenX;
                const diff = touchStartX - touchEndX;

                if (Math.abs(diff) > 50) {
                    if (diff > 0) {
                        nextImage();
                    } else {
                        prevImage();
                    }
                }
            },
            { passive: true }
        );
    }

    // ─────────────────────────────────────────────────────────────────────────────
    // DATA EXTRACTION LAYER (REPLACES NETWORK API)
    // Strategy:
    //   1. Grab the hidden Judge.me HTML widget from the page
    //   2. Parse it locally into a DOM structure
    //   3. Extract all reviews in exactly the same format the API used to return
    // ─────────────────────────────────────────────────────────────────────────────

    async function fetchAllReviews() {
        const template = document.getElementById('judgeme-widget-data');

        // 1. Parse the hidden Judge.me widget template first (priority) — this is the
        //    real, live review HTML Shopify rendered server-side from the
        //    `judgeme.all_reviews_widget` metafield, so there's no CORS/network call
        //    involved and it reflects the store's actual current reviews (much more
        //    than the small bundled sample in step 3 below).
        const templateReviews = await parseTemplateReviews(template);
        if (templateReviews.length > 0) {
            return templateReviews;
        }

        // 2. Try the live Judge.me API as a secondary attempt (kept for completeness —
        //    Judge.me's public API does not allow direct browser/CORS calls in
        //    practice, so this will normally fail silently and fall through).
        let allReviews = [];
        const domainsToTry = [
            CONFIG.shopDomain,
            'yaynuts.myshopify.com',
            'e12094-9a.myshopify.com'
        ];
        for (const domain of domainsToTry) {
            try {
                for (let page = 1; page <= CONFIG.maxPages; page++) {
                    const response = await $.ajax({
                        url: `https://judge.me/api/v1/reviews`,
                        method: 'GET',
                        data: {
                            api_token: CONFIG.apiToken,
                            shop_domain: domain,
                            per_page: CONFIG.perPage,
                            page: page
                        },
                        dataType: 'json',
                        crossDomain: true,
                        timeout: 5000
                    });

                    const pageReviews = response.reviews || [];
                    if (!pageReviews.length) break;

                    allReviews = allReviews.concat(pageReviews);
                }

                if (allReviews.length > 0) break; // Found reviews, stop trying domains
            } catch (err) {}
        }
        if (allReviews.length > 0) {
            return allReviews;
        }

        // 3. Last resort: the bundled local JSON sample (only ~24 reviews) — only used
        //    if both the server-rendered widget and the live API came back empty.
        const localJsonUrl = template?.dataset.reviewsJson;
        if (localJsonUrl) {
            try {
                const response = await fetch(localJsonUrl);
                if (response.ok) {
                    const data = await response.json();
                    if (data && data.reviews) {
                        return data.reviews;
                    }
                }
            } catch (err) {}
        }

        return [];
    }

    // Parses the hidden <template id="judgeme-widget-data"> — the server-rendered
    // Judge.me review HTML — into the same shape fetchAllReviews() normally returns.
    function parseTemplateReviews(template) {
        return new Promise((resolve) => {
            if (!template || !template.content) {
                return resolve([]);
            }

            const reviewElements = template.content.querySelectorAll('.jdgm-rev, .jdgm-carousel-item, .jdgm-widget-review');
            const rawReviews = [];

            reviewElements.forEach((el) => {
                const id = el.getAttribute('data-review-id') || el.getAttribute('data-id') || Math.random().toString(36).substr(2, 9);
                const ratingStr = el.querySelector('.jdgm-rev__rating, .jdgm-carousel-item__rating, [data-score]')?.getAttribute('data-score');
                const rating = ratingStr ? parseInt(ratingStr, 10) : 5;
                const title = el.querySelector('.jdgm-rev__title, .jdgm-carousel-item__review-title, .jdgm-rev__review-title')?.textContent?.trim() || '';
                const body = el.querySelector('.jdgm-rev__body, .jdgm-carousel-item__review-body, .jdgm-rev__review-body')?.textContent?.trim() || '';
                const author = el.querySelector('.jdgm-rev__author, .jdgm-carousel-item__reviewer-name, .jdgm-rev__reviewer-name')?.textContent?.trim() || 'Anonymous';
                const verifiedElement = el.querySelector('.jdgm-rev__buyer-badge, .jdgm-carousel-item__buyer-badge, .jdgm-verified-badge');
                const verified = verifiedElement ? 'verified-purchase' : '';
                const timestamp = el.querySelector('.jdgm-rev__timestamp, .jdgm-carousel-item__timestamp, .jdgm-rev__review-date')?.getAttribute('data-content') || '';

                // Specific Review Image Selectors (Avoid Product/Avatar images)
                const reviewImageSelectors = [
                    '.jdgm-rev__pic-img', 
                    '.jdgm-rev__pic-link img',
                    '.jdgm-carousel-item__review-image',
                    '.jdgm-rev__picture img',
                    'img.jdgm-image'
                ].join(',');
                
                const pictureElements = el.querySelectorAll(reviewImageSelectors);
                const pictures = Array.from(pictureElements).map(elem => {
                    // Try data-src first (lazy loading), then src
                    let url = elem.getAttribute('data-src') || 
                              elem.getAttribute('src') || 
                              elem.closest('a')?.getAttribute('data-media-url') ||
                              elem.closest('a')?.getAttribute('href');
                    
                    if (!url) return null;
                    
                    // Filter out non-image Judge.me UI elements
                    const isInternal = url.includes('avatar') || 
                                     url.includes('widget-stars') || 
                                     url.includes('data:image') || 
                                     url.includes('blank.gif');
                    
                    if (isInternal) return null;

                    // Ensure it's a Judge.me media host or a valid image extension
                    const isMediaHost = url.includes('cloudinary.com') || 
                                      url.includes('judgeme.imgix.net') || 
                                      url.includes('cdn.shopify.com');
                    
                    const isImageFile = url.match(/\.(jpg|jpeg|png|webp|gif|avif)/i);

                    if (!isMediaHost && !isImageFile) return null;

                    if (url.startsWith('//')) {
                        url = 'https:' + url;
                    }
                    return url;
                }).filter(Boolean);
                const uniquePictures = [...new Set(pictures)];

                if (!body && uniquePictures.length === 0) return; // Skip empty skeletons

                rawReviews.push({
                    id: id,
                    rating: rating,
                    title: title,
                    body: body,
                    reviewer: { name: author },
                    verified: verified,
                    created_at: timestamp,
                    product_title: 'Perfect Pecans',
                    pictures: uniquePictures,
                    cf_answers: []
                });
            });

            // The server-rendered .jdgm-rev list never embeds the actual customer
            // photo <img> tags (Judge.me lazy-loads those client-side), so the pool
            // above always comes back with 0 images. The real photo URLs live in a
            // separate .jdgm-gallery-data[data-json] blob Judge.me embeds per product
            // widget on the page — parse those and merge the pictures into the
            // matching review (by id), or add the review if it wasn't in the list above.
            const byId = new Map(rawReviews.map((r) => [String(r.id), r]));
            const galleryEls = template.content.querySelectorAll('.jdgm-gallery-data[data-json]');
            const stripHtml = (html) => {
                const tmp = document.createElement('div');
                tmp.innerHTML = html || '';
                return tmp.textContent?.trim() || '';
            };

            galleryEls.forEach((el) => {
                let entries = [];
                try {
                    entries = JSON.parse(el.getAttribute('data-json')) || [];
                } catch (err) {
                    return;
                }

                entries.forEach((entry) => {
                    const picUrls = Array.isArray(entry.pictures_urls)
                        ? entry.pictures_urls.map((p) => p.original || p.compact).filter(Boolean)
                        : [];
                    if (picUrls.length === 0) return;

                    const id = String(entry.uuid || Math.random().toString(36).substr(2, 9));
                    const existing = byId.get(id);
                    if (existing) {
                        existing.pictures = [...new Set([...(existing.pictures || []), ...picUrls])];
                        return;
                    }

                    byId.set(id, {
                        id: id,
                        rating: entry.rating ? parseInt(entry.rating, 10) : 5,
                        title: entry.title || '',
                        body: stripHtml(entry.body_html),
                        reviewer: { name: entry.reviewer_name || 'Anonymous' },
                        verified: entry.verified_buyer ? 'verified-purchase' : '',
                        created_at: entry.created_at || '',
                        product_title: 'Perfect Pecans',
                        pictures: picUrls,
                        cf_answers: []
                    });
                });
            });

            resolve(Array.from(byId.values()));
        });
    }

    // ─────────────────────────────────────────────────────────────────────────────
    // DATA TRANSFORMATION
    // ─────────────────────────────────────────────────────────────────────────────

    function transformReviews(rawReviews) {
        return rawReviews
            .map((review) => {
                const helpful = getHelpfulCounts(review.id);

                return {
                    id: String(review.id),
                    rating: clampRating(review.rating),
                    title: review.title || review.product || review.product_title || 'Customer Review',
                    body: review.body || '',
                    name: review.author || review.reviewer?.name || 'Anonymous',
                    verified: review.verified === true || VERIFIED_STATUSES.has(String(review.verified || '').toLowerCase()),
                    createdAt: review.created_at,
                    timeAgo: formatTimeAgo(review.created_at),
                    variant: review.product || review.product_title || 'Review',
                    images: normalizeImages(review.images || review.pictures),
                    cfAnswers: Array.isArray(review.cf_answers) ? review.cf_answers : [],
                    upvotes: helpful.up,
                    downvotes: helpful.down,
                    vote: helpful.vote
                };
            })
            .filter((review) => review.body || review.images.length > 0);
    }

    function normalizeImages(pictures) {
        if (!Array.isArray(pictures)) {
            return [];
        }

        return pictures
            .map((picture) => {
                let url = '';
                if (typeof picture === 'string') {
                    url = picture;
                } else if (picture?.urls) {
                    url = picture.urls.original || picture.urls.huge || picture.urls.large || picture.urls.compact || picture.urls.small;
                } else {
                    url =
                        picture?.urls?.original ||
                        picture?.urls?.large ||
                        picture?.urls?.compact ||
                        picture?.urls?.small ||
                        picture?.url ||
                        '';
                }

                if (!url) return null;

                // 1. Strict filtering of non-image URLs
                // Must be a known image format OR a known media CDN
                const isMediaCDN = url.includes('cloudinary.com') || 
                                 url.includes('judgeme.imgix.net') || 
                                 url.includes('cdn.shopify.com');
                
                const isImageExtension = url.match(/\.(jpg|jpeg|png|webp|gif|avif)/i);

                if (!isMediaCDN && !isImageExtension) return null;

                // If it contains a '#' or is a generic product link, it's likely a mistake
                if ((url.includes('#') || url.includes('/products/')) && !isMediaCDN) {
                    return null;
                }

                // 2. Upgrade resolution
                // Judge.me/Shopify suffixes: _small, _thumb, _compact, _medium, _large
                // CDN params: w=150, h=150
                let highResUrl = url
                    .replace(/_small\./g, '_original.')
                    .replace(/_thumb\./g, '_original.')
                    .replace(/_compact\./g, '_original.')
                    .replace(/_medium\./g, '_original.')
                    .replace(/_large\./g, '_original.')
                    .replace(/w=150/g, 'w=1024')
                    .replace(/h=150/g, 'h=1024')
                    .replace(/width=150/g, 'width=1024')
                    .replace(/height=150/g, 'height=1024')
                    .replace(/([?&]width=)\d+/g, '$11024');

                return highResUrl;
            })
            .filter(Boolean)
            .filter((url, index, urls) => urls.findIndex((other) => getPhotoKey(other) === getPhotoKey(url)) === index);
    }

    // Judge.me stores each upload as "<upload-ts>__<client-ts>-<original-filename>", and the
    // same photo can reach us twice: once as a small thumbnail from the review list and once
    // full-size from the gallery data, or uploaded twice by the customer (same original
    // filename, different timestamps). Key photos by the original filename, ignoring size
    // params and upload prefixes, so each photo shows once. Generic names phones give every
    // upload ("image.jpg", "photo.jpg") don't identify a photo, so those keep the full upload
    // name and two different pictures are never merged.
    function getPhotoKey(url) {
        const file = (String(url).split('?')[0].split('/').pop() || '').toLowerCase();
        const original = file.replace(/^\d+__\d+-/, '');
        return /^(image|photo|picture|img|file)(\s*\(\d+\))?__original\./.test(original) ? file : original;
    }

    // ─────────────────────────────────────────────────────────────────────────────
    // RENDER FUNCTIONS
    // ─────────────────────────────────────────────────────────────────────────────

    function renderLoadingState() {
        elements.gallery.innerHTML =
            '<div class="w-full py-10 text-center text-[#014465]">Loading review photos...</div>';
        elements.writtenReviewsList.innerHTML =
            '<div class="border-t-[2px] pt-6 text-[#014465]">Loading written reviews...</div>';
    }

    function renderErrorState(error) {
        const message = error?.message || 'Unable to load reviews right now.';

        elements.gallery.innerHTML = `<div class="w-full py-10 text-center text-[#014465]">${escapeHtml(message)}</div>`;
        elements.writtenReviewsList.innerHTML = `<div class="border-t-[2px] pt-6 text-[#014465]">${escapeHtml(
            message
        )}</div>`;

        if (elements.writtenReviewsShowMore) {
            elements.writtenReviewsShowMore.hidden = true;
        }
    }

    function renderSummary() {
        // Average + total come straight from shop.metafields.judgeme.all_reviews_rating/count —
        // real, live numbers Judge.me computes and Shopify re-renders on every page load, not a
        // static guess. Judge.me doesn't expose a live per-star breakdown to the storefront (the
        // .jdgm-histogram element ships empty — it's normally filled in by Judge.me's own script,
        // which we don't load), so the star bars are the real total split proportionally by the
        // rating mix of the reviews we actually parsed off the page — real review data, just a
        // sample-based split rather than an exact count.
        const template = document.getElementById('judgeme-widget-data');
        const trueTotal = template?.dataset.totalReviews ? parseInt(template.dataset.totalReviews, 10) : state.reviews.length;
        const trueAverage = template?.dataset.averageRating ? parseFloat(template.dataset.averageRating).toFixed(1) : getAverageRating(state.reviews);

        const sampleBreakdown = getRatingBreakdown(state.reviews);
        const sampleTotal = state.reviews.length;
        const breakdown = {};
        [5, 4, 3, 2, 1].forEach((rating) => {
            breakdown[rating] = sampleTotal > 0 ? Math.round((sampleBreakdown[rating] / sampleTotal) * trueTotal) : 0;
        });
        const finalTotal = trueTotal;

        if (elements.reviewsAverageRating) {
            const averageEls = document.querySelectorAll('.reviewsAverageRating');
            averageEls.forEach(el => el.textContent = trueAverage);
        }
        if (elements.reviewsAverageStars) {
            const rect = elements.reviewsAverageStars.querySelector('svg > rect');
            if (rect) {
                const origWidth = parseFloat(rect.getAttribute('data-original-width') || rect.getAttribute('width'));
                if (!rect.hasAttribute('data-original-width')) rect.setAttribute('data-original-width', origWidth);
                rect.setAttribute('width', (origWidth * (trueAverage / 5)).toString());
            }
        }

        const basedOnText = `Based on ${formatCount(finalTotal, true)} reviews`;
        if (elements.reviewsBasedOnText) {
            elements.reviewsBasedOnText.textContent = basedOnText;
        }
        
        const totalCountEls = document.querySelectorAll('.reviewsTotalCount');
        totalCountEls.forEach(el => el.textContent = basedOnText);

        if (elements.galleryReviewsCount) {
            elements.galleryReviewsCount.textContent = `${formatCount(finalTotal, true)} reviews`;
        }
        if (elements.reviewsMetaCount) {
            elements.reviewsMetaCount.textContent = `${formatCount(finalTotal, true)} reviews`;
        }

        [5, 4, 3, 2, 1].forEach((rating) => {
            const fill = document.querySelector(`[data-rating-fill="${rating}"]`);
            const count = document.querySelector(`[data-rating-count="${rating}"]`);

            const scaledCount = breakdown[rating] || 0;
            const percent = finalTotal ? scaledCount / finalTotal : 0;

            if (percent !== null && fill) {
                fill.style.width = `${percent * 100}%`;
            }
            if (scaledCount !== null && count) {
                count.textContent = formatCount(scaledCount);
            }
        });

        renderHeaderMetrics(Number(trueAverage));
    }

    function renderHeaderMetrics(fallbackAverage) {
        // These per-metric badges (Value for Money, Ease of Use, etc.) used to be derived from
        // custom-question answers on the same small state.reviews sample used before TRUE_STATS
        // existed — same problem as the old average: a small, unrepresentative sample producing
        // a number (e.g. 4.7) that didn't match the real 4.4 shown everywhere else. They now all
        // just mirror the one real average so the page never shows conflicting numbers.
        updateMetricText(elements.potionRating, fallbackAverage);
        updateMetricText(elements.convenienceRating, fallbackAverage);
        updateMetricText(elements.easyRating, fallbackAverage);
        updateMetricText(elements.flavorRating, fallbackAverage);
        updateMetricText(elements.valueRating, fallbackAverage);
    }

    function extractMetricAverages() {
        const lookup = {
            potion: [],
            convenience: [],
            easy: [],
            flavors: [],
            valueForMoney: []
        };

        state.reviews.forEach((review) => {
            review.cfAnswers.forEach((answer) => {
                const label = normalizeMetricLabel(
                    answer?.question ||
                    answer?.question_title ||
                    answer?.label ||
                    answer?.cf_question?.question ||
                    answer?.cf_question?.title ||
                    answer?.cf_question_name ||
                    ''
                );
                const value = parseMetricValue(answer?.value ?? answer?.answer ?? answer?.text ?? '');

                if (!label || value == null) {
                    return;
                }

                if (label.includes('potion')) {
                    lookup.potion.push(value);
                } else if (label.includes('convenience')) {
                    lookup.convenience.push(value);
                } else if (label.includes('easy')) {
                    lookup.easy.push(value);
                } else if (label.includes('flavor')) {
                    lookup.flavors.push(value);
                } else if (label.includes('value') || label.includes('money')) {
                    lookup.valueForMoney.push(value);
                }
            });
        });

        return {
            potion: getArrayAverage(lookup.potion),
            convenience: getArrayAverage(lookup.convenience),
            easy: getArrayAverage(lookup.easy),
            flavors: getArrayAverage(lookup.flavors),
            valueForMoney: getArrayAverage(lookup.valueForMoney)
        };
    }

    function renderGallery() {
        if (!elements.gallery) return;

        if (!state.mediaReviews.length) {
            elements.gallery.innerHTML =
                '<div class="w-full py-10 text-center text-[#014465]">No review photos available yet.</div>';
            return;
        }

        // Expand mediaReviews so if a review has 3 images, we show 3 gallery items.
        // Skip a photo the same reviewer already posted in another review.
        const galleryItems = [];
        const seenPhotos = new Set();
        state.mediaReviews.forEach((review) => {
            review.images.forEach((image, imgIndex) => {
                const photoId = `${review.name.toLowerCase()}|${getPhotoKey(image)}`;
                if (seenPhotos.has(photoId)) return;
                seenPhotos.add(photoId);
                galleryItems.push({
                    review: review,
                    image: image,
                    imgIndex: imgIndex
                });
            });
        });

        elements.gallery.innerHTML = galleryItems
            .map((item, index) => {
                const image = item.image || CONFIG.fallbackImage;
                return `
                    <a
                        href="${escapeAttribute(image)}"
                        class="gallery-link flex-shrink-0 snap-start cursor-zoom-in"
                        data-index="${index}"
                        aria-label="Open review photo by ${escapeAttribute(item.review.name)}"
                    >
                        <img
                            src="${escapeAttribute(image)}"
                            alt="${escapeAttribute(item.review.variant)}"
                            class="gallery-img w-[200px] h-[200px] object-cover shadow-sm"
                        >
                    </a>
                `;
            })
            .join('');

        elements.gallery.querySelectorAll('.gallery-link').forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                // When clicking an item, we need to find which mediaReview it corresponds to
                const itemIndex = Number(link.dataset.index);
                const item = galleryItems[itemIndex];
                
                // Find index of this review in state.mediaReviews
                const reviewIndex = state.mediaReviews.indexOf(item.review);
                openModal(reviewIndex);
            });
        });
    }

    function renderWrittenReviews() {
        const visibleReviews = state.reviews.slice(0, state.writtenVisibleCount);

        elements.writtenReviewsList.innerHTML = visibleReviews
            .map((review) => {
                return `
                    <div class="border-t-[2px] border-[#3D348B] border-dotted pt-6" data-review-id="${escapeAttribute(review.id)}">
                        <div class="flex justify-between text-sm gap-4">
                            <div class="flex gap-2 items-center flex-wrap">
                                <span class="font-medium text-[12px] sm:text-[12px] md:text-[20px] lg:text-[20px] xl:text-[20px] text-[#014465]">
                                    ${escapeHtml(review.name)}
                                </span>
                                ${review.verified
                        ? `<span class="text-[#3D348B] text-[12px] sm:text-[12px] md:text-[16px] lg:text-[18px] xl:text-[18px] font-bold flex justify-center items-center gap-2">
                                            <span class="w-4">
                                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8 16C3.58698 16 0 12.413 0 8C0 3.58698 3.58698 0 8 0C12.413 0 16 3.58698 16 8C16 12.413 12.413 16 8 16Z" fill="#3D348B"></path>
                                                    <path d="M6.9443 10.6643C6.79547 10.6643 6.65407 10.6047 6.54988 10.5005L4.44384 8.39449C4.22802 8.17868 4.22802 7.82147 4.44384 7.60565C4.65965 7.38984 5.01686 7.38984 5.23267 7.60565L6.9443 9.31728L10.7694 5.49217C10.9852 5.27635 11.3424 5.27635 11.5583 5.49217C11.7741 5.70798 11.7741 6.06519 11.5583 6.281L7.33872 10.5005C7.23453 10.6047 7.09314 10.6643 6.9443 10.6643Z" fill="white"></path>
                                                </svg>
                                            </span>
                                            Verified Buyer
                                        </span>`
                        : ''
                    }
                            </div>
                            <span class="text-[#3D348B] text-[12px] sm:text-[12px] md:text-[16px] lg:text-[16px] xl:text-[16px]">
                                ${escapeHtml(review.timeAgo)}
                            </span>
                        </div>

                        <div class="mt-2 text-[#FFB800] text-[22px] leading-none">${renderTextStars(review.rating)}</div>

                        <h4 class="text-[20px] sm:text-[20px] md:text-[32px] lg:text-[32px] xl:text-[32px] font-bold text-[#014465] mt-[18px]">
                            ${escapeHtml(review.title)}
                        </h4>

                        <p class="text-[13px] sm:text-[13px] md:text-[16px] lg:text-[16px] xl:text-[16px] text-[#014465] mt-2 w-[85%] leading-[18px] sm:leading-[30px] md:leading-[30px] lg:leading-[30px] xl:leading-[30px]">
                            ${escapeHtml(review.body)}
                        </p>

                        <div class="flex justify-between mt-3 text-xs text-gray-500 gap-4">
                            <span class="text-[#014465]">${escapeHtml(review.variant)}</span>
                            <div class="likes flex jusfiy-center items-center gap-3">
                                <span>Was this helpful?</span>
                                <button type="button" class="flex items-center gap-1 cursor-pointer text-[#014465] ${review.vote === 'up' ? 'font-bold' : ''}" data-helpful="up" data-review-id="${escapeAttribute(
                        review.id
                    )}">
                                    <span><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <rect width="19" height="19" fill="url(#pattern0_191_392)"/> <rect width="19" height="19" fill="#3D348B" style="mix-blend-mode:screen"/> <defs> <pattern id="pattern0_191_392" patternContentUnits="objectBoundingBox" width="1" height="1"> <use xlink:href="#image0_191_392" transform="translate(0 -0.426517) scale(0.00421941)"/> </pattern> <image id="image0_191_392" width="512" height="512" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/> </defs> </svg></span>
                                    <span data-inline-helpful-up="${escapeAttribute(review.id)}">${review.upvotes}</span>
                                </button>
                                <button type="button" class="flex items-center gap-1 cursor-pointer text-[#014465] ${review.vote === 'down' ? 'font-bold' : ''}" data-helpful="down" data-review-id="${escapeAttribute(
                        review.id
                    )}">
                                    <span><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <rect width="19" height="19" fill="url(#pattern0_191_393)"/>
                                    <rect width="19" height="19" fill="#3D348B" style="mix-blend-mode:screen"/>
                                    <defs>
                                    <pattern id="pattern0_191_393" patternContentUnits="objectBoundingBox" width="1" height="1">
                                    <use xlink:href="#image0_191_393" transform="translate(-1.18803 -0.721437) scale(0.0042735)"/>
                                    </pattern>
                                    <image id="image0_191_393" width="512" height="512" preserveAspectRatio="none" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAQAElEQVR4AezdvbIzxbk24OXvMD6qtnMCsk2ViZ1DQGAiUiIHEJkDMBEERKRE3gEBzh3jKpwRkLOr8Gl4z71YWu/60U/3aGbUPX29pXm1JPX09HO1pHmm50f/784/AgQIECBAYDgBCcBwXS5gAgQIECBwdycB8C4gQIAAAQIDCkgABux0IRMgQIDA2AKJXgIQBRMBAgQIEBhMQAIwWIcLlwABAgRGF/gtfgnAbw7+J0CAAAECQwlIAIbqbsESIECAwOgCh/glAAcJ9wQIECBAYCABCcBAnS1UAgQIEBhd4E38EoA3Fv4iQIAAAQLDCEgAhulqgRIgQIDA6AJP45cAPNXwNwECBAgQGERAAjBIRwuTAAECBEYXeB6/BOC5h0cECBAgQGAIAQnAEN0sSAIECBAYXeBl/BKAlyIeEyBAgACBAQQkAAN0shAJECBAYHSB1/FLAF6beIYAAQIECOxeQAKw+y4WIAECBAiMLnAsfgnAMRXPESBAgACBnQtIAHbewcIjQIAAgdEFjscvATju4lkCBAgQILBrAQnArrtXcAQIECAwusCp+CUAp2Q8T4AAAQIEdiwgAdhx5wqNAAECBEYXOB2/BOC0jVcIECBAgMBuBSQAu+1agREgQIDA6ALn4pcAnNPxGgECBAgQ2KmABGCnHSssAgQIEBhd4Hz8EoDzPl4lQIAAAQK7FJAA7LJbBUWAAAECowtcil8CcEnI6wQIECBAYIcCEoAddqqQCBAgQGB0gcvxSwAuGylBgAABAgR2JyAB2F2XCogAAQIERhcoiV8CUKKkDAECBAgQ2JmABGBnHSocAgQIEBhdoCx+CUCZk1IECBAgQGBXAhKAXXWnYAgQIEBgdIHS+CUApVLKESBAgACBHQlIAHbUmUIhQIAAgdEFyuOXAJRbKUmAAAECBHYjIAHYTVcKhAABAgRGF6iJXwJQo6UsAQIECBDYiYAEYCcdKQwCBAgQGF2gLn4JQJ2X0gQIECBAYBcCEoBddKMgCBAgQGB0gdr4JQC1YsoTIECAAIEdCEgAdtCJQiBAgACB0QXq45cA1JuZgwABAgQIdC8gAei+CwVAgAABAqMLzIlfAjBHzTwECBAgQKBzAQlA5x2o+QQIECAwusC8+CUA89zMRYAAAQIEuhaQAHTdfRpPgAABAqMLzI1fAjBXznwECBAgQKBjAQlAx52n6QQIECAwusD8+CUA8+3MSYAAAQIEuhWQAHTbdRpOgAABAqMLXBO/BOAaPfMSIECAAIFOBSQAnXacZhMgQIDA6ALXxS8BuM7P3AQIECBAoEsBCUCX3abRBAgQIDC6wLXxSwCuFTQ/AQIECBDoUEAC0GGnaTIBAgQIjC5wffwSgOsN1UCAAAECBLoTkAB012UaTIAAAQKjCywRvwRgCUV1ECBAgACBzgQkAJ11mOYSIECAwOgCy8QvAVjGUS0ECBAgQKArAQlAV92lsQQIECAwusBS8UsAlpJUDwECBAgQ6EhAAtBRZ2kqAQIECIwusFz8EoDlLNVEgAABAgS6EZAAdNNVGkqAAAECowssGb8EYElNdREgQIAAgU4EJACddJRmEiBAgMDoAsvGLwFY1lNtBAgQIECgCwEJQBfdpJEECBAgMLrA0vFLAJYWVR8BAgQIEOhAQALQQSdpIgECBAiMLrB8/BKA5U3VSIAAAQIEmheQADTfRRpIgAABAqMLrBG/BGANVXUSIECAAIHGBSQAjXeQ5hEgQIDA6ALrxC8BWMdVrQQIECBAoGkBCUDT3aNxBAgQIDC6wFrxSwDWklUvAQIECBBoWEAC0HDnaBoBAgQIjC6wXvwSgPVs1UyAAAECBJoVkAA02zUaRoAAAQKjC6wZvwRgTV11EyBAgACBRgUkAI12jGYRIECAwOgC68YvAVjXV+0ECBAgQKBJAQlAk92iUQQIECAwusDa8UsA1hZWPwECBAgQaFBAAtBgp2gSAQIECIwusH78EoD1jS2BAAECBAg0JyABaK5LNIgAAQIERhfYIn4JwBbKlkGAAAECBBoTkAA01iGaQ4AAAQKjC2wTvwRgG2dLIUCAAAECTQlIAJrqDo0hQIAAgdEFtopfArCVtOUQIECAAIGGBCQADXWGphAgQIDA6ALbxS8B2M7akggQIECAQDMCEoBmukJDCBAgQGB0gS3jlwBsqW1ZBAgQIECgEQEJQCMdoRkECBAgMLrAtvFLALb1tjQCBAgQINCEgASgiW7QCAIECBAYXWDr+CUAW4tbHgECBAgQaEBAAtBAJ2gCAQIECIwusH38EoDtzS2RAAECBAjcXEACcPMu0AACBAgQGF3gFvFLAG6hbpkECBAgQODGAhKAG3eAxRMgQIDA6AK3iV8CcBv3Wy71/08Lf3+a/nZk+sv0XF5LmelPNwIECBDYq4AEYK89+zqurNh/mZ7+dZq+n6Y/HZn+Oj2X11ImZZMQSAYmFDcCBAisJXCreiUAt5LfbrlZgWdrPyv2/6pYbMomIUgykPlTT8XsihIgQIBAywISgJZ75/q2/fdURVbg2dqf/px9y/ypJyMCsysxIwECBAi8FLjdYwnA7ezXXnK22H9ceCEZEfjPVGd2J0x3bgQIECDQq4AEoNeeu9zuf14uMrtEdidkt8DsCsxIgAABAnd3tzSQANxSf71lZ6g++/DXW8LdXXYL5EDBjDSsuRx1EyBAgMAKAhKAFVBvXGVWyBmq36IZSTJybECONdhieZZBgACBHQncNhQJwG3911j6x2tUeqHOHGvguIALSF4mQIBASwISgJZ6Y5m2bLX1/7K1OS5AEvBSxWMCBAicELj10xKAW/fAssuvHYr/fFr8u9P0wTTl7/+Z7q+5JQmobcM1yzMvAQIECMwUkADMhGt0tj9WtCsr/i+m8v+apr9PU/7+aLp/a5qSDEx3s27ZHSAJmEVnJgIExhG4faQSgNv3wZIteKewsmzpZ8V/rPi/pyeTDCQRSLnpYfXtu2mOHIw43bkRIECAQIsCEoAWe2X9NpWs2JMIZEQguwdqW5SzA9a8DkFte5QnQIBAUwItNEYC0EIvtN2G7B7I7oL/rWxmkoBcj6ByNsUJECBAYAsBCcAWyv0vI7sL/jCFUZsE5IwEZwZMcG4ECBB4I9DGXxKANvqhh1Zkl8CcJODrHoLTRgIECIwmIAEYrcevi3dOEpBdAX434Dp3cxMgsCOBVkKRALTSE/20Y04SkN8NcGpgP32spQQIDCAgARigk1cIMUnAh5X15tTAylkUJ0CAwN4E2olHAtBOX/TWkhwYWHOKYHYFOCCwt17WXgIEdisgAdht124SWE4RLLmmwKExDgg8SLgnQGBIgZaClgC01Bt9tuWzimYbBajAUpQAAQJrCkgA1tQdo+4cD1CzK8AowBjvC1ESIPBKoK0nJABt9UevrcmugNKLBBkF6LWXtZsAgV0JSAB21Z03DebPFUvPaYEVxRUlQIBA/wKtRSABaK1H+m1PzShAEgC/FthvX2s5AQI7EJAA7KATGwqhZhTg44barSkECBBYWaC96iUA7fVJzy2qGQX4pOdAtZ0AAQK9C0gAeu/B9tr/TWGTcjCg3QCFWIoRINC3QIutlwC02Ct9t+nbiub7fYAKLEUJECCwpIAEYElNdUUg1wUovTpgDgbMPCYCBAjsWKDN0CQAbfZL762SAPTeg9pPgMDuBSQAu+/imwSYHwoqXbDjAEqllCNAoEuBVhstAWi1Z/puV3YDlF4Z0HEAffe11hMg0KmABKDTjuug2T8UtvHtwnKKESBAoEOBdpssAWi3b3pv2U+FAbxTWE4xAgQIEFhQQAKwIKaqngn849mj0w/eO/2SVwgQINC3QMutlwC03Dv1bWvptLpfC5ufCwIVFlWMAAECBJYSkAAsJXn7et6vaELNUfoV1T4rmgMBnz1x5oEzAc7geIkAgV4F2m63BKDt/qlpXenWf47Or1k517ThZdks6+Vzxx6/dexJzxEgQIDAegISgPVst665NAEovVb/Eu0vPRNgiWWpgwABAk0JtN4YCUDrPVTWvppz6UsPzitb8jKl7AJYxlEtBAgQKBaQABRTNV3w04rWbbH/v6I5ihIgQGCPAu3HJAFov49KWlg6/F96jf6SZSpDgAABAh0LSAA67ryHptcM/0sAHtDcESBAYE2BHuqWAPTQS+fbWDP8//fzVd3sVZcDvhm9BRMgMKqABKD/nt/D8P/P/XeDCAgQIHAQ6ONeAtBHP51qZc3Ff1oe/jcCcKqHPU+AAIGVBCQAK8FuVG3p1n+a0+rwf9pmBCAKJgIEdiHQSxASgF566nU7c+58aQLw+evZPUOAAAECIwtIAPrt/Y8rmt7ixX8qmq8oAQIEehHop50SgH766mVLP3n5xInHuR5/6xf/2eq3CU4QeZoAAQLjCUgA+uzznPtf+jO6W177/6Xmey+f8JgAAQJ7FugpNglAT731pq015/5/+2a2Zv/6tdmWaRgBAgR2KiAB6K9jaw7+y6l/txxeLx2l6K8XtJgAAQKvBPp6QgLQV3+ltTUH/yUByDytT7dMUlq30T4CBAisIiABWIV11Ur/Wlh7Dv675bn/GakobKpiBAgQ6F+gtwgkAH312F8qmnvLg//SzLfyX8GURKWgmCIECBAgsKSABGBJzfXrKj31Ly259cF/pSMAP6SxJgIECPQt0F/rJQD99Fmu+196UF32/d96v7rr+/fz3tJSAgQGFJAA9NPpX1c09auKsmsVfaew4p8KyylGgACBZgV6bJgEoI9eq936b/3Kf0/V/RDQUw1/EyBAYCMBCcBG0Fcupret/4RbehXAW++qSFtNBAgQuEKgz1klAO33W83Wf46ob2Xrv/R4BVcBbP89qIUECOxQQALQfqfWbP3/uZFwSs8ASHONAETBRIBAtwK9NlwC0HbP5bz/0i3pbP3f8sI/TyXzY0VPH5/6O20+9ZrnCRAgQGBFAQnAirhXVp2t6NKr/mVRrWz9py2lpwDmGgCJs8UpcZgIECBwQaDflyUA7fbdlxVNy5Z0K1v/aXbpKYB/mgrnGIAWp/9Mbcv0y3T/t4cpIzKloxvTLG4ECBBoV0AC0GbfZCWTlWNp6z4sLbhRudIzADZqzlWLyS6Y9EWmjMj8ONWWxCBJQRKCjF5MT7kRIDCiQM8xSwDa7L3vKpqVq/61cuT/odlZaR7+3uv9ISHI6EVGCXK2xl5jFRcBAjsUkAC016nZqqxZgX7WWAgjbhGnv76f+iEjA+m/EQ2m8N0IjCbQd7wSgLb6L0P/GWYubVW2/ls7jS4xlLZ/j+XSfxkVkAjssXfFRGBHAhKAtjqzZug/LW9t6z9tKj0DIGX3PB0SAbsG9tzLYhtaoPfgJQDt9GAOKstQcmmLPpgKtrb1PzXprvQMgJQdYcqugfSt3QIj9LYYCXQkIAFoo7OylZiDykpbk6H/lk77e9rumjiezrfnv2PyzynA0XePTARuBPYi0H8cxFgPlgAAEABJREFUEoDb92FWCtlKrGlJi0P/ab+t3CgcnzK6k1MIk+wdL+FZAgQIbCggAdgQ+8iissKs3e//+VRPi0P/U7Pu3pr+y0WJ9jBNoaxyS7InCViFVqUEthPYw5IkALftxQwLZ8uwtBVZsX5RWvgG5XI9gt9Py93D9LspjkzvTvc53iKJV/ynh1ffkgRk5OfqilRAgACBuQISgLly18+XA8NqVv5Z4h/yn2lTgSQ1Od4iiVcSm4xyJCHIcRjXNCS7AzICdE0d5iVA4CYC+1jouQQgX07ZStnjlNhu2YNZ+efAsJo2ZKXT6tB/TRy9l00fJCH4aAokycA1iUBGgKZqhr/l85jvmewa2duUuBLf8J0MoD2BlwlA3qhZOeWKZrmYSbZS9jgltly+NRdr2bJX4pvl1q78s5LJSmfLtlrWZYEkA9ckAhkB2vo9eDmq7Upk5Zjvm3we8z2TXSN7mxJX4svnPsnNdrqWtJrAXip+mgDkzZk3au3KqVeLfPnmYi35YGbFvHYcWUa2+LLcmmVlv3NWMjXzKLutwCERyChN7ZLzHsx7o3a+3ssn8cnKcaTvmyQ3SXh67zvt34nAIQHIyj9vzp2EVRVGVshZMVfNVFk4WzpJrrKsylnv7PevFbtd+YzSZLdAkraaVtT89HNNva2Wzco/iU+r7VuzXUl4WkkCknjmuynf/5nSL6a7uwsGR19Pn16aUm+c477me6y47iQAacyoK/8DVFbM6bzD4yXv0+nZ0plTZ45Az9blnHnNcxuB9FcOFqxJArJSyOfwNi3edqlZ4Yy68j9Ip7/zvXB4vNV9Vj5ZbkY9n+7mzfd/pvSL6e5ujkH69NKUeuOcjcGsb9IfW/X90eUkAfj46CvjPZnOW/JLOF90+aCl0+doZjg5R6DPmdc8txfIyE1NEjDK5/DT23dNEy34ZKNWZCWTlU1W+Fn55PsoGzwbLX5/i1kooqxv0h9ZR2RdsVC1ddUkAdjqjVjXstuUXqIjkkTkA5et/rkftKz8M5x8GwVLXUIgIwEfVlSUL+aK4t0WzRdft41fsOH5blji++ZYk/IdlC39w0qf+TGlNp7L+yDriiRqm7coCUAasPmCG13gNb9klw9zVvwZ3rnmA2fl3+ibY0azMoKTCwiVzpr3UGnZHsvtPb7aPsmKunaeS+Wz4s930CgJ5SWPhV9frbqMBqTvVlvAsYqTABx7ftTnan/JLl9o6bQM4ySLu2bFH3Mr/yjsa/q2Ipw/VpRVtH+BazY4Xkaf76J8D1nxv5Tp53H6LuuTzVosAainzlBNtvQzvJaVfjptiVEUK//6vuhhjuwKyHUcStpam4CW1KnM/gWy0sh30RLfQ/vXuiLCDWbN+iTrmA0WdXcnAahn/nqa5dot/amKx1sOFMvR/vb5P5Ls7o/SBGDJ99XuEAV0VCAbI1lpHH3Rk10KZHdARnRWb7wEYHXiswvIiiFHi2df8dmCXuxaQHLXdfc12fgcP5Ahf0njZt2z6YK+m5aWPp7u1rtJANazvVRzDg7LFf4yRHyprNf7F8hIT0kUq3/oSxqhTNMCeY/k4mWG/Jvupqsal75d/QJhEoCr+mjWzFkRZMg/vy43qwIz7VogVxLcdYCCu0pg6ZV/vo8yEpkpGyWmu7ujBlOvnXs+x3A9nfIdf3ic+eI8VVF1y+jOqscDSACq+uPqwnkj5CpxhvyvplQBgeEEllj5Z0WU76GsoH43Ceb7KCORmbJRYrq7m2OQ3XxPp3zHHx6nvjjHPP4Te/Etx5wVF64tKAGoFZtXPh+4bNnljTCvBnMRIDC6wDXD/tnCzwooK6J8D2UFNbpnRfyLFI15/NMXpRVmV8BqowASgNJumFfu6Yrfvv55hnuZKx/kklhyEZeScsqMJZCj/UvfQ09lssWZFX+28LMCevqav28jkL5Iv5QufbVRAAlAaRfUlzts8Vvx19vtbY4M3ZbG5P1SKjVOuZznn/3BtRFnAyRbnFb8tXIvyq/wMGd/lVabxG+VUQAJQGkXKEdgvkDpOb01WwXzW2POUwIZmj0cuJX7rEDz3KnyWzyf5HHOef5pf4b6t2ijZdQLJNFPH5XOOScBvFi3BOAikQIErhYoveTrD1cvSQVzBPJFnAPiMjR7OHAr91mB5rmM5iUZmFP3tfPM+ZXIDPmn/dcu2/z3Aqv9lz4qTfqTACQZXLQxEoBFOVVG4KhA6S9u/nR0bk+uJZCt+6zc80V8bhnZWksykBXruXJrvFb63jksO2005H/QaP/+zxVNLB1JLK5SAlBMpSCBWQL50GYfXsnM/ygppMwiAln5Z+s+K/fSCrNiTcJQWv7actniK33vZFlW/lFYeFq5uiSfNaMAizZHArAop8oIvBL49NUzp5/ICub0q15ZUuCzmZUlYcgug5mzrzZb2uT9sxrvqhV/U1h7dgMUFi0rJgEoc1KKwByBbMGVfmizRTpnGeapF8jKMivy+jl/myNbba31V9r0W+v8v6DAJlV9W7GUjChWFD9fVAJw3serBK4RqDmAq7UVyjVxtz7vEivLr1oPUvu6EUgyWrob4I9LRiUBWFJTXQSeC9ScvrXESun50j06JrBUomW4/Zjuzp7bMJzS3QDvLNkmCcCSmuoiME/gVqeYzWtt33MteabFUslE36Jav4TAz4WVvFdYrqiYBKCISSEC1QLZ/186U80+wNI6lTsuUPpFe3xuzw4ksGmopSNKNWeFXAxAAnCRSAECswRqThfLPsBZCzETAQK7EKj5DljsQEAJwC7eO4JoUKDmR31qRgsaDLWrJpVelbEkqEWHY0sWqMx2AjdYUumBgIt9X0gAbtDLFjmEQDL60g/0Yhn9ELLXBbnkQVSLDsdeF5a5dyBQeinwxZJYCcAO3jVCaFZg8w90sxLtNCzXZVhiC2qVX2drh2n0ltwk/tIDVGsvD30yGAnASRovELhaoPQDveRW6dWNHqCCLxeI8esF6lAFgTkCGXn625wZX84jAXgp4jGB5QRKr+1vX/Jy5iU1ZRTgmt0uf5kWki/h6c5tjwI3iqnmDJW8h69OAiQAN+ppix1CoPRAQCuT7d8OP06LnJMEZOVfc4GnaTFuBIoEai8GliTgql1REoCiflGIwCyBHAg4a0YzbSKQJKDmC9TKf5NuufVCbrr82ouCfT+1dk4iO812dycBuGfwH4HVBErPBFjiwLTVgthxxfkCzVDqqUQg/ZIV/y+TgS3/CcFtVYE5FwX7bm6LJABz5cxHgMBeBDKUmkTgP1NAWdEnIciUv7MbJyt+u2kmnBFuN44xo4YfVLYh780kqZWzGQGoBjMDgZUEaq4cuFITVDsJ5Ms0CUGm/D095UZgU4EcC1CbBCRJzWhVVUONAFRxKUyAAAEC+xVoJrI5SUD16a0SgGb6W0MGF8hQ8+AEwidA4IlAkoCaX5zMqFXVAYESgCfa/iSwgoBh5BVQVUlgDYEG6/xoalPpgcRT0btP81/pJAEolVKOQL1AzT65HPxTvwRzECCwd4EPKwLMKEDx944EoEJWUQKVAqXDcTUZfmUTFCdAoEyg2VL/mlpWc32Aj6fyRTcJQBGTQgRmCSQbL5mx9EeDSupShgCB/Ql8URFSzggoKi4BKGJSiEC1QIbhShOA0h8Nqm6EGQgQKBPooFTNKMCpC1s9C1MC8IzDAwKLCfyzoqbSHw2qqFJRAgR2JlBzlcCijQ8JwM7eIcK5uUC2/HMVudKj/7P/P/v4bt5wDSAwrkAXkedA4dLTAt8riUgCUKKkDIEygVyOM+fzF2XfD1V+83DvjgABApcEvrpU4OH1bIBkY+Th4fE7CcBxF88SqBXIyr/44JsnldcM6z2ZzZ8ECCwl0FE9NaOFF89CkgB01POaujuBHNSTYb3dBSYgAgRWEyjdDXBxJFICsFofqZjARYGaU3suVqYAAQJzBLqbp/SsoYvHAUgAuut7DW5U4OfKdr1bWV5xAgQIRKD0rKEcB5DyJycJwEkaLxBYTSA/9VmzL2+1hqiYwOgCHca/2HeHBKDD3tfkrgWy/y6/8tV1EBpPgEAXAmcPBJQAdNGHGkmAAAECywt0W2OuH3J14yUAVxOqgAABAgQIbCpQ+vshZ68FIAHYtM8sjAABAgRaERi9HRKA0d8B4idAgACB3gRKTwV8+1xgEoBzOl4jUC5w9oP2pJrSD+6TWfxJgMDyAmqUAHgPECBAgACBAQUkAAN2upBXEXinsNbaCwYVVqsYAQI1Asre3UkAvAsILCNw8bKbD4tx7f8HCHcECKwukB8oO3ktAAnA6v4WMIjAxctuPjjk54If/nRHgMBtBLpfaumIYwL9cfrv6OmAEoBJxo3AlQInM+wj9RoBOILiKQIEVhX48ljtEoBjKp4jUCfwx8Lii1y9q3BZihEgcEJgwKf/NMX8/jQ9u0kAnnF4QGCWQOlwXOnVu2Y1wkwECBA4I/D1y9ckAC9FPCZQJ5B9a8muS+bKDwGVlFOGAIHVBHZR8WdTFJ9PU80txyk9GwWQANTwKUvgtcDHr586+cxiP+N5cgleIEBgBIEcS/TFFOi701Sza/HZxooEYNJzI3CFwCeF8+ZDmg9tYXHFCBBYQ2BndWaj4g8VMUkAKrAUJXBOIMNpGVY7V+bw2jeHP9wTIEBgQYFsWHxQUd/jWUtGACrUFCXwQuDVQTUvXn/68NunD/xNgMAtBHa7zL9PkWWUcbq7eHs8a0kCcNFKAQJHBWq2/vPBTJZ+tCJPEiBAYAGB0lHGx7OWJAALqKtiOIEc+f99RdR/riirKAECKwnsvNrS3xl5vGy5BGDn7wjhrSJw9KpaJ5aUrf8Mz5142dMECBBYRCAHBFZVJAGo4lKYwF2G/p8dSXvBpHRY7kI1XiZA4DqB3c9dupvx8cBlCcDu3xMCXFAgR8/WDP1n6z/n6i7YBFURIEBgGQEJwDKOatm/QFb++VWtmkjt+6/RUpbAigKqfi3QQwKQrahcQjVT/n4dhWcIrCswZ+Wf96t9/+v2i9oJELhCoNUEICv6XNjgd1Nsv5+mjx6m/J3n8lrKTE+7EVhd4LsZS8i1umfMZhYCBJYXGKLGnJ1UFWiLCUB+4CAr+nNbT3ktZVK2KmCFCVQK5KC/x4NmCudNglp6QE5hlYoRIEDgrMBbZ1998+LjxnNrCUC+OGsOmkrZ/BjCm9D8RWBZgZoj/rNkQ/9RMBFoSGCQppSOAPxw8GgpAcjWfLbsD20rvc+5j0kcSssrR6BUIB+omgQgmXV2V5XWrxwBAgSWEni7tqJWEoB8cWZrvrb9h/JJHLLldXjsnsASAqVDallW3sM1v8qVeUwECKwuMMwCHi/xeyHinw6vt5IALHG61FeHoNwTWEggIwClVWXlb79/qZZyBAgsLfB4id8LFT9eMriVBCBb8BfafPHl7ArIVtjFggoQKBQoHVLL6JOVfyGqYgS2FBhkWdlYKT1YOevKe5YWEoB8ed43ZoH/Hg9uWK74y1YAABAASURBVKAuVRAoFXgcUiudQTkCBAgsKJBrlZRW97ix0kICsOSX55J1lWIqt1+B0n1qj0Nq+6UQGYEeBYZpc81o5SNKCwnAY2P8QaAxgdIzAB4z6sbarzkECIwhULoR8uw4gRYSgNKtrDG6UZStCGSfWmlbfi0tqBwBAtsJDLSk0o2QHCeQi5vd07SQADzLSO5bNf8/ycR8O3M+Fyjdp5YDT0s/fM+X4BEBAgSWEajZCHkc2WwhAUhGUrO1dYordTwGdqqQ5wkUCpS+lxx4WgiqGIFtBYZaWjZCSg+oz3db1pd3LSQA6aUv89+V08dXzm92Ak8F8iF5+vjU3w48PSXjeQIEthSouRbO/fqylQQgX7alQ67HQJPN/PXYCzd87h74hsu36PkCNe/Ff8xfjDkJEFhLYMB6c35/dkmWhP5JCrWSAKQt303/ZUU+3VXf/lk9x/ozJCF5PNhi/cVZwoICn1bUlQ9dRXFFCRAgsJpA6VV1s+u9mV0A0UiDsiKvSQJS9pdp5sw73W1yq9nn+/3UIknAhNDRLe+pjEiVNLl0n1tJXcoQILCYwLAV1WyQvN/SCEB6LCvyHM34lzy4MKVMymaeC0UXfbn2S18SsCj/6pXVHI9S+15YvfEWQIDA0AI1BwO+3VoCcOi5DJ//Z3rwt2nKij5b0Znyd57Laykzvbz5bc7vFiQJSNs3b6wFVglk33/p1n/2tc15L1Q1SGECBOoFBp+j9MDkd1pNAA79ly/jrOizAs2Uv/Pc4fVb3X8wY8Fpe5KXGbOaZSOBHIdSuqhvSgsqR4AAgQ0Fiq8K2HoCsKFZ1aKy5fd51Ry/FU7ykmMWMprx2zP+b0UgyVnN7qRvW2m4dhCYBPK9YpRxgri7G/6/0uMA/ksCMP+98sU065x9wFnJZDQjH1iJwITYwC1fnEnOSpuSfs++ttLyyhFYWyDfKxllzO7RvJ/XXp762xUo/m6SAFzXiR9Ns2dlMN1V3/KBTSJw+MAmGcgR6NUVmWG2QLyz5Z8vzppKPqsprCyBjQXyfh52A2Nj664XJwG4vvuSBOSAsGtqygc2yUDOasgHNyulTMnkTXd3cwySUD2dcoDf4XHqi2+8a7b808fZ9VOcYWcGE4EbCBw2MPI+T6J7gyZYZOsCEoBleuj3UzXXJgFTFfe3fHCzUsqUxMB0dzfHIAnV0+nHSffwOPXFd3qq6pY+zq6fqpkUJnBDgbzPk+gm+b1hM7ZatOVMAsUJnwRg0lroliRg7u6AhZqgmpUFPly5ftUTWEsgyW9GA9aqX73tCLxV2JT/lQAUShUWy+6ADBEXFlesI4Gc+ll6dG1HYWnqQAIZDcguxuItxN5stPde4I/3/1/+7wcJwGWk2hIZIs7KonY+5dsVSFKXUz/bbaGW7VEgx5rkvbfkyGJ2MdZecn2PtnuO6f6HfgoC/EkCUKA0o0hWFhmGWfKDO6MZZllAIH2YpG6BqlRBoFog772MLP5umjMbFnk/Tn9edUsSkOMCcmDsVRW1NbPWTALp0/Tv9OfF288SgItGswske88HNx/aHDw2uyIz3kwgX7bpw5s1YGcLzkpnZyFdFU7pFdsOC8mGRd6PSyUDOTA2K4xD/e77F6j6JdMkAFZObzq99BrKb+a4/Fc+tDlAMEN5rC97tVIi/ZUv21bas4d2JCneQxxLxXCNR75X8v58d2pMEtXpbtZtN0nArOj3NVPO9MhxHiVR5T3z7yQArmn+hmvNy7tmKC+JQEYEgv9mqf5qSSBJWvoo/dVSu/bSFu/933oy77MlDipNHUkE8p79reb6/5MEODCw3q2lOTKSkzM9Stt0/zlMArDmSq+0MS2UC8g1GXlpDIfMPcN4yd6zpZlll86v3DoC+ULOl2iStPTROktR61cI7gX+fP//cv/lPXvNcUedHxi4HGSHNSV5SxJX0/S8X+6SAGSlly++mpn3VjZf/re4vGuy92xpJoNPQpAPcJKC9EemJAemu7s5BkmqLk2pN85xt+Lf5lOd93zct1lam0vJ+/L+C3jh5uW7PN8leU/XVp0Dx5IE1M6n/G0FsuVfe2zN4+cvCUCanzfjnDdN5u19ysr/D1MQ+fBMdze9pQ35gkx/ZEpyYLq7m2OQL8JLU+qNc9xv2vGDLTzuj19Cg8WelX/el2uGnfd0NiRql5EkoMuLBdUGupPyuaR57ZZ/1nf5/N0THBKAPMibJltCeYPm8d6nQORLKFt+VgB7723xtSaQL6GspEb5vkmc2chae+V/6OdsSOT7PN9zh+dK7nMQWQ4mKymrzG0EstWfCzrlkua1LXi26+lpApCKsiLMGzTD0flw5g27xykfjKz48yWUuE0ECGwvkJXU0++bfOfsccr3aeLMRtaWyvk+z+hmbRKQg8myktmyrVcsa5hZ0ycZoclWf0ZragNPEvrsPfgyAXhaYT6cKbzHKR+Mp7H6mwCB2wrk+2av0y1l8103Jwn47paNtuxHgRzgl6H+bPFnxZ8RmscXK/5IEpgk9Nks5xKAZwU9IECAAIEuBQ5JQE3js4WZFU/NPDcpu6OFZmWfrfzsgsmWflb6OcAvQ/3pj2tCTRL4an4JwCsSTxAgQGB3AkkCsnulJrCseLIyqplny7JpW1aSe5j+M8FlZZ+t/OyCyZb+tSv9qcr7W/o9/X//4Ol/EoCnGv4mQIDAfgWyiyXHdNVE+HVN4e3L3mUluYdpDboM++d4t/T70folAEdZPEmAAIFdCuSYrpz9VBpcVq6t7go4uWIrDW7H5bLyz7D/0S3/Q9wSgIOEewIECIwhkLOfsoIojTa7ArJvurT8VuX+vdWCOltOEryc5XZ25Z+YJABRMBEgQGAsgWwd1kTc6lkBObWtJo49l01Sl/39SfCK4pQAFDEpRIAAgV0JZOuw5niA7ArIQXcNIdw35af7//132Oqv2i0iAfDGIUCAwJgCOR6gZgs6R6e3JvVzaw3auD1Z8edCU8Vb/U/bJwF4quFvAgQIjCVQ+yNozRwQ+NBNGcl4+HOYuyRtGb2ZveI/SEkADhLuCRAgMJ5AVqDZiiyNPAcE5oI1peXXLlc15L12Y1as/7DSz2l9uaJfRm+uXpwE4GpCFRAgQKBrgQwf5wCy0iC+LC24XrlnNde0/dmMDT5ILFnZJynLVn5W+NnSP6z0k7At1mwJwGKUKiJAgEC3Ah9WtDxXqWtpFOCHwrZnpZoVaotTVvKZcvpeVvZJyrKVv+gK/6WTBOCliMcECBAYTyBD6dnyLI38pqMALxpZeibAO9N8WaG2OE1N2/4mAdje3BIJECDQokDNAYEtjQKMfibA7PeSBGA2nRkJECCwK4FsGWeYvDSoG40CvGpe2v3qySNPvHfkuaGfkgAM3f2CJ0CAwDOBb589Ov+glVGA7L4439LfXs3FjH77y//3AhKAewb/ESBAgMAkkK3pmlGAj6d5Nr1dubCWDl68MpTrZ5cAXG+oBgIECOxJoGYUINcFaCH2nD5X0o4Wf9SopN2rlJEArMKqUgIECHQrUDsKsOHVAU+alp4KeLKCEV+QAIzY62ImQIDAeYGaUYBPzle1yaulpwK+vUlrOlmIBKCTjtJMAgQIbCiQUYDS6wLk4LpNhtYXiD/XAligmn1UIQHYRz+KggABAksLfFVR4acVZdco6loAM1QlADPQzEKAAIEBBHJ6XekowAanBJ4Vz4jF2QIPL7oWwANE7iQAUTARIECAwDGB0gQg897ylMBf0wBTnYAEoM5LaQIECIwkkB+kKT3FbtWDARdCz/EKC1XVfzUSgP77UAQECBBYU+Cbwsqzcr3VwYCluwAKQxmjmARgjH4WJQECBOYK1JwSuNLBgHObbr5zAhKAczpeI0CAAIFsXZceC5CDAVsXcznghx6SADxAuCNAgACBkwKlCUAqeD//LTkV1lV6rEJhdfsvJgHYfx+LkAABAtcK5GDA0jpaHwV4qzSQvZeTAOy9h8VHgACBZQRKfyUwCcCCw+zLNF4trwUkAK9NPEOAAAECrwX+8fqpk8/c8poAJxvlhecCEoDnHh4RIECAwHGBXBmwdD/7YtfcP94Uzy4hIAFYQlEdBAgQGEOg9JoAdgN08H6QAHTQSZpIgACBRgRqrgmwwEWBGol6p82QAOy0Y4VFgACBFQRyTYDS3QAZBVihCVdX6XcDHgglAA8Q7ggQIECgSGCz3QBFrXlTKJcifvPIXxcFJAAXiRQgQIAAgScCve8GyCjGk3DG/VMCMG7fi5wAAQJzBLIC3WA3wJymmadGQAJQo6UsAQIECESgZjdAyq89lV54qDRxWbu9TdQvAWiiGzSCAAECXQnUXBSodOX8DKDygTMOKsFSXAIQBRMBAgQI1AjkokA15dcu+3bhAn4oLDdEMQnAEN0sSAIECCwusOJwenVbS688+FN1zTueQQKw484VGgECBAYReK8wzp8Lyw1RTAIwRDcLkgABAv0IVLY0xxiUXgOgtV0XlaEuW1wCsKyn2ggQIEBgW4GaAwBzCuO2rWt4aRKAhjtH0wgQIDCeQHXEpZcc/p/qmnc+gwRg5x0sPAIECOxcoDQBcADgizeCBOAFiIcECBAgcDuByiXXDP/XXLugshl9FpcA9NlvWk2AAAECd3efViA4APAFlgTgBYiHBAgQIHArgarl5uj/0uF/+/+P0EoAjqB4igABAgSaF/i4ooVfVZQdpqgEYJiuFigBAgTaFqhs3V8Ly+eKhYb/j2BJAI6geIoAAQIEmhb4S0XrSn+5sKLKfRSVAOyjH0VBgACBzgWKm599/6Vb/6n02/xnei0gAXht4hkCBAgQaFfgy4qm5eA/V/87ASYBOAHjaQIECBDYTqBwSTnvv/TI/1Tp4L8onJgkACdgPE2AAAECzQl8V9GibP07+O8MmATgDI6XCBAgQGALgaJl/G0qVfqrf1PRu8/yn+m0gATgtI1XCBAgQKANgfenZtQM/Wfr377/Ce3cTQJwTsdrBAgQILC6wIUFZL//9xfKvHzZ1v9LkSOPJQBHUDxFgAABAk0I5JS/Hytb8sFU3tb/hHDpJgG4JOR1AgQIEFhR4GTVWfn/evLV4y9k6P/vx1/y7EsBCcBLEY8JECBA4NYCGfavXfmnzYb+o1A4SQAKoRQjQIAAgeUFjtSYA/5qh/1TjaH/KFRMEoAKLEUJECBAYFWBXOO/9oC/NOjz6T9D/xNCzU0CUKOlLAECBAjUCpz52d7HqjLk/8v0qOYa/1Px+1v2+39x/5f/qgQkAFVcChMgQIDAg8APD/eX7j6ZCuSAvunu1S0r/lzgJ0P+NRf5OVSUn/q13/+gUXkvAagEU5wAAQIE7gV+uv//8n9Zsf9zKpZ9+1nh5z5D/b9Mz2XFX3OBn2mWZ7c/TI+c8jchzLlJAOaomYcAAQIEan5mN0lA9u1nhZ/7DPXnuWsU35pmtvKfEObeJABz5cxHgACBsQWy8s3+95kKs2fLsL+V/2y+NzNKAN4eyi/GAAAHkklEQVRY+IsAAQIE6gS2TgCy8jfsX9dHJ0tLAE7SeIEAAQIELgjk1LtZScCFeo+9nOX8fnohIw/Tndu1AhKAawXNT4AAgbEFtjgKP+f5fzQ28/LRSwCWN1UjAQIERhLIFnmuwlcRc3HRDPm/O5V2nv+EsPRNArC0qPoIECAwnkB2BSydBGSrP0P+/xqPc5uIJQDbOFsKAQIE9i6QJCBb69lqPxvrhRez4v/dVMZW/4Sw5k0CsKauugkQIDCWQLbWs9We0YCaRCAH+GUeK/4N3y8SgA2xLYoAAQKDCGQ0IIlARgSyRZ8V/MN0d7jP84eVfg7wyzyD8LQRpgSgjX7QCgIECOxRICMCGcrPCv7llOet9G/Y6xKAG+JbNAECBEYTEG87AhKAdvpCSwgQIECAwGYCEoDNqC2IAAECowuIvyUBCUBLvaEtBAgQIEBgIwEJwEbQFkOAAIHRBcTfloAEoK3+0BoCBAgQILCJgARgE2YLIUCAwOgC4m9NQALQWo9oDwECBAgQ2EBAArABskUQIEBgdAHxtycgAWivT7SIAAECBAisLiABWJ3YAggQIDC6gPhbFJAAtNgr2kSAAAECBFYWkACsDKx6AgQIjC4g/jYFJABt9otWESBAgACBVQUkAKvyqpwAAQKjC4i/VQEJQKs9o10ECBAgQGBFAQnAiriqJkCAwOgC4m9XQALQbt9oGQECBAgQWE1AArAarYoJECAwuoD4WxaQALTcO9pGgAABAgRWEpAArASrWgIECIwuIP62BSQAbfeP1hEgQIAAgVUEJACrsKqUAAECowuIv3UBCUDrPaR9BAgQIEBgBQEJwAqoqiRAgMDoAuJvX0AC0H4faSEBAgQIEFhcQAKwOKkKCRAgMLqA+HsQkAD00EvaSIAAAQIEFhaQACwMqjoCBAiMLiD+PgQkAH30k1YSIECAAIFFBSQAi3KqjAABAqMLiL8XAQlALz2lnQQIECBAYEEBCcCCmKoiQIDA6ALi70dAAtBPX2kpAQIECBBYTEACsBiliggQIDC6gPh7EpAA9NRb2kqAAAECBBYSkAAsBKkaAgQIjC4g/r4EJAB99ZfWEiBAgACBRQQkAIswqoQAAQKjC4i/NwEJQG89pr0ECBAgQGABAQnAAoiqIECAwOgC4u9PQALQX59pMQECBAgQuFpAAnA1oQoIECAwuoD4exSQAPTYa9pMgAABAgSuFJAAXAlodgIECIwuIP4+BSQAffabVhMgQIAAgasEJABX8ZmZAAECowuIv1cBCUCvPafdBAgQIEDgCgEJwBV4ZiVAgMDoAuLvV0AC0G/faTkBAgQIEJgtIAGYTWdGAgQIjC4g/p4FJAA99562EyBAgACBmQISgJlwZiNAgMDoAuLvW0AC0Hf/aT0BAgQIEJglIAGYxWYmAgQIjC4g/t4FJAC996D2EyBAgACBGQISgBloZiFAgMDoAuLvX0AC0H8fioAAAQIECFQLSACqycxAgACB0QXEvwcBCcAeelEMBAgQIECgUkACUAmmOAECBEYXEP8+BCQA++hHURAgQIAAgSoBCUAVl8IECBAYXUD8exGQAOylJ8VBgAABAgQqBCQAFViKEiBAYHQB8e9HQAKwn74UCQECBAgQKBaQABRTKUiAAIHRBcS/JwEJwJ56UywECBAgQKBQQAJQCKUYAQIERhcQ/74EJAD76k/RECBAgACBIgEJQBGTQgQIEBhdQPx7E5AA7K1HxUOAAAECBAoEJAAFSIoQIEBgdAHx709AArC/PhURAQIECBC4KCABuEikAAECBEYXEP8eBSQAe+xVMREgQIAAgQsCEoALQF4mQIDA6ALi36eABGCf/SoqAgQIECBwVkACcJbHiwQIEBhdQPx7FZAA7LVnxUWAAAECBM4ISADO4HiJAAECowuIf78CEoD99q3ICBAgQIDASQEJwEkaLxAgQGB0AfHvWUACsOfeFRsBAgQIEDghIAE4AeNpAgQIjC4g/n0LSAD23b+iI0CAAAECRwUkAEdZPEmAAIHRBcS/dwEJwN57WHwECBAgQOCIgATgCIqnCBAgMLqA+PcvIAHYfx+LkAABAgQIvBKQALwi8QQBAgRGFxD/CAISgBF6WYwECBAgQOCFgATgBYiHBAgQGF1A/GMISADG6GdREiBAgACBZwISgGccHhAgQGB0AfGPIiABGKWnxUmAAAECBJ4ISACeYPiTAAECowuIfxwBCcA4fS1SAgQIECDwKCABeKTwBwECBEYXEP9IAhKAkXpbrAQIECBA4EFAAvAA4Y4AAQKjC4h/LAEJwFj9LVoCBAgQIHAvIAG4Z/AfAQIERhcQ/2gCEoDRely8BAgQIEBgEpAATAhuBAgQGF1A/OMJSADG63MREyBAgACBOwmANwEBAgSGFwAwooAEYMReFzMBAgQIDC8gARj+LQCAAIHRBcQ/poAEYMx+FzUBAgQIDC4gARj8DSB8AgRGFxD/qAISgFF7XtwECBAgMLSABGDo7hc8AQKjC4h/XAEJwLh9L3ICBAgQGFhAAjBw5wudAIHRBcQ/soAEYOTeFzsBAgQIDCsgARi26wVOgMDoAuIfW+D/AAAA//8K86t8AAAABklEQVQDALM5vlsU4F9PAAAAAElFTkSuQmCC"/>
                                    </defs>
                                    </svg>
                                    </span>
                                    <span data-inline-helpful-down="${escapeAttribute(review.id)}">${review.downvotes}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                `;
            })
            .join('');

        elements.writtenReviewsList.querySelectorAll('[data-helpful]').forEach((button) => {
            button.addEventListener('click', () => {
                const reviewId = button.getAttribute('data-review-id');
                const direction = button.getAttribute('data-helpful');
                updateHelpfulVote(direction, reviewId);
            });
        });

        if (elements.writtenReviewsShowMore) {
            elements.writtenReviewsShowMore.hidden = state.writtenVisibleCount >= state.reviews.length;
        }
    }

    function showMoreReviews() {
        state.writtenVisibleCount += CONFIG.initialWrittenReviews;
        renderWrittenReviews();
    }

    function applySortFilter(type) {
        let filtered = [...state.allReviews];

        if (type === 'media') {
            filtered = filtered.filter(review => review.images.length > 0);
        }

        switch (type) {
            case 'recent':
            case 'media':
                filtered.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
                break;
            case 'oldest':
                filtered.sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
                break;
            case 'helpful':
                filtered.sort((a, b) => b.upvotes - a.upvotes);
                break;
            case 'least_helpful':
                filtered.sort((a, b) => a.upvotes - b.upvotes);
                break;
            case 'highest_rating':
                filtered.sort((a, b) => b.rating - a.rating);
                break;
            case 'lowest_rating':
                filtered.sort((a, b) => a.rating - b.rating);
                break;
        }

        state.reviews = filtered;
        state.mediaReviews = state.allReviews.filter((review) => review.images.length > 0);

        // Re-sort mediaReviews based on current sort direction if it makes sense
        if (type === 'recent' || type === 'media') {
            state.mediaReviews.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
        } else if (type === 'oldest') {
            state.mediaReviews.sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
        }

        state.writtenVisibleCount = CONFIG.initialWrittenReviews;
        state.currentIndex = 0;

        renderGallery();
        renderWrittenReviews();

        if (elements.writtenReviewsShowMore) {
            elements.writtenReviewsShowMore.hidden = state.reviews.length <= state.writtenVisibleCount;
        }
    }

    // ─────────────────────────────────────────────────────────────────────────────
    // MODAL / LIGHTBOX
    // ─────────────────────────────────────────────────────────────────────────────

    function openModal(index) {
        if (!state.mediaReviews.length) {
            return;
        }

        state.currentIndex = index;
        updateModalContent();
        renderThumbnails();
        elements.modal.classList.remove('hidden');
        elements.modal.classList.add('active');
        document.body.classList.add('modal-open');

        setTimeout(() => {
            elements.modalClose?.focus();
        }, 100);
    }

    function closeModal() {
        elements.modal.classList.remove('active');
        elements.modal.classList.add('hidden');
        document.body.classList.remove('modal-open');
    }

    function updateModalContent() {
        const review = state.mediaReviews[state.currentIndex];

        if (!review) {
            return;
        }

        const image = review.images[0] || CONFIG.fallbackImage;
        elements.modalImage.src = image;
        elements.modalImage.alt = `${review.variant} review photo by ${review.name}`;
        elements.reviewerName.textContent = review.name;
        elements.timeAgo.textContent = review.timeAgo;
        elements.productVariant.textContent = review.variant;
        elements.reviewText.textContent = review.body;
        elements.upCount.textContent = review.upvotes;
        elements.downCount.textContent = review.downvotes;
        renderStars(elements.starRating, review.rating);

        if (elements.reviewerAvatar) {
            elements.reviewerAvatar.textContent = review.name.charAt(0).toUpperCase();
        }

        if (elements.verifiedBadge) {
            elements.verifiedBadge.style.display = review.verified ? '' : 'none';
        }

        elements.thumbUp?.classList.toggle('font-bold', review.vote === 'up');
        elements.thumbDown?.classList.toggle('font-bold', review.vote === 'down');
        updateThumbActive();
    }

    function renderThumbnails() {
        elements.thumbStrip.innerHTML = state.mediaReviews
            .map((review, index) => {
                const image = review.images[0] || CONFIG.fallbackImage;
                return `
                    <button
                        class="thumb w-16 h-16 rounded overflow-hidden flex-shrink-0 ${index === state.currentIndex ? 'active' : ''}"
                        data-index="${index}"
                        aria-label="View review by ${escapeAttribute(review.name)} - ${escapeAttribute(review.variant)}"
                    >
                        <img src="${escapeAttribute(image)}" alt="${escapeAttribute(review.variant)}" class="w-full h-full object-cover">
                    </button>
                `;
            })
            .join('');

        elements.thumbStrip.querySelectorAll('.thumb').forEach((thumb) => {
            thumb.addEventListener('click', () => {
                goToImage(Number(thumb.dataset.index));
            });
        });
    }

    function updateThumbActive() {
        elements.thumbStrip.querySelectorAll('.thumb').forEach((thumb, index) => {
            thumb.classList.toggle('active', index === state.currentIndex);
        });

        const activeThumb = elements.thumbStrip.querySelector('.thumb.active');
        activeThumb?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    function goToImage(index) {
        if (!state.mediaReviews.length) {
            return;
        }

        if (index < 0) {
            state.currentIndex = state.mediaReviews.length - 1;
        } else if (index >= state.mediaReviews.length) {
            state.currentIndex = 0;
        } else {
            state.currentIndex = index;
        }

        updateModalContent();
    }

    function nextImage() {
        goToImage(state.currentIndex + 1);
    }

    function prevImage() {
        goToImage(state.currentIndex - 1);
    }

    function scrollGallery(direction) {
        elements.gallery.scrollBy({ left: direction * 216, behavior: 'smooth' });
    }

    // ─────────────────────────────────────────────────────────────────────────────
    // HELPFUL VOTES
    // ─────────────────────────────────────────────────────────────────────────────

    function submitVoteToJudgeMe(reviewId, direction) {
        // Only send if it's a real numeric ID from Judge.me (random local IDs have letters)
        if (!reviewId || !/^\d+$/.test(String(reviewId))) return;

        try {
            const url = `https://judge.me/reviews/${reviewId}/${direction === 'up' ? 'upvote' : 'downvote'}`;
            fetch(url, { method: 'POST', mode: 'no-cors' }).catch(() => { });
        } catch (e) { }
    }

    function updateHelpfulVote(direction, explicitReviewId) {
        const reviewId = String(explicitReviewId || state.mediaReviews[state.currentIndex]?.id);
        const review = state.allReviews.find((item) => String(item.id) === reviewId);

        if (!review) {
            return;
        }

        const previousVote = review.vote;

        if (previousVote === direction) {
            review.vote = '';
            if (direction === 'up') {
                review.upvotes = Math.max(0, review.upvotes - 1);
            } else {
                review.downvotes = Math.max(0, review.downvotes - 1);
            }
        } else {
            review.vote = direction;
            if (direction === 'up') {
                review.upvotes += 1;
                if (previousVote === 'down') {
                    review.downvotes = Math.max(0, review.downvotes - 1);
                }
            } else {
                review.downvotes += 1;
                if (previousVote === 'up') {
                    review.upvotes = Math.max(0, review.upvotes - 1);
                }
            }
        }

        submitVoteToJudgeMe(review.id, direction);
        persistHelpfulState(review);
        
        // Update references in filtered lists
        state.reviews = state.reviews.map(r => r.id === review.id ? review : r);
        state.mediaReviews = state.mediaReviews.map(r => r.id === review.id ? review : r);

        renderWrittenHelpfulCounts(review);
        updateModalContent();
    }

    function renderWrittenHelpfulCounts(review) {
        const up = document.querySelector(`[data-inline-helpful-up="${review.id}"]`);
        const down = document.querySelector(`[data-inline-helpful-down="${review.id}"]`);

        if (up) {
            up.textContent = review.upvotes;
            const btn = up.closest('button');
            if (btn) btn.classList.toggle('font-bold', review.vote === 'up');
        }
        if (down) {
            down.textContent = review.downvotes;
            const btn = down.closest('button');
            if (btn) btn.classList.toggle('font-bold', review.vote === 'down');
        }
    }

    // ─────────────────────────────────────────────────────────────────────────────
    // STAR RENDERING
    // ─────────────────────────────────────────────────────────────────────────────

    function renderStars(container, rating) {
        container.innerHTML = Array.from({ length: 5 }, (_, index) => {
            const filled = index < rating;
            return `
                <svg class="w-5 h-5 ${filled ? 'star' : 'text-gray-300'}" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
            `;
        }).join('');
    }

    function renderTextStars(rating) {
        return `${'★'.repeat(rating)}${'☆'.repeat(Math.max(0, 5 - rating))}`;
    }

    // ─────────────────────────────────────────────────────────────────────────────
    // KEYBOARD / ACCESSIBILITY
    // ─────────────────────────────────────────────────────────────────────────────

    function handleDocumentKeydown(event) {
        if (!elements.modal.classList.contains('active')) {
            return;
        }

        if (event.key === 'Escape') {
            closeModal();
        } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            prevImage();
        } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            nextImage();
        }
    }

    function trapModalFocus(event) {
        if (event.key !== 'Tab') {
            return;
        }

        const focusableElements = elements.modal.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstFocusable) {
            event.preventDefault();
            lastFocusable.focus();
        } else if (!event.shiftKey && document.activeElement === lastFocusable) {
            event.preventDefault();
            firstFocusable.focus();
        }
    }

    // ─────────────────────────────────────────────────────────────────────────────
    // HELPFUL STATE PERSISTENCE (localStorage)
    // ─────────────────────────────────────────────────────────────────────────────

    function loadHelpfulState() {
        try {
            return JSON.parse(localStorage.getItem(CONFIG.helpfulStorageKey) || '{}');
        } catch (_error) {
            return {};
        }
    }

    function getHelpfulCounts(reviewId) {
        const helpful = state.helpful[String(reviewId)] || {};
        return {
            up: Number(helpful.up) || 0,
            down: Number(helpful.down) || 0,
            vote: helpful.vote || ''
        };
    }

    function persistHelpfulState(review) {
        state.helpful[review.id] = {
            up: review.upvotes,
            down: review.downvotes,
            vote: review.vote
        };

        try {
            localStorage.setItem(CONFIG.helpfulStorageKey, JSON.stringify(state.helpful));
        } catch (_error) {
            // localStorage unavailable (private browsing, storage full) — votes will still
            // work for this page session; they just won't persist across reloads.
        }
    }

    // ─────────────────────────────────────────────────────────────────────────────
    // UTILITIES
    // ─────────────────────────────────────────────────────────────────────────────

    function updateMetricText(element, value) {
        if (element && value != null) {
            const numVal = Number(value);
            element.textContent = numVal.toFixed(1);
            if (element.previousElementSibling) {
                updateMetricStars(element.previousElementSibling, numVal);
            }
        }
    }

    function updateMetricStars(svgContainer, rating) {
        if (!svgContainer) return;
        const rects = svgContainer.querySelectorAll('g > rect');
        if (rects.length === 5) {
            rects.forEach((rect, index) => {
                const originalWidth = parseFloat(rect.getAttribute('data-original-width') || rect.getAttribute('width'));
                if (!rect.hasAttribute('data-original-width')) {
                    rect.setAttribute('data-original-width', originalWidth);
                }
                const starFill = Math.max(0, Math.min(1, rating - index));
                rect.setAttribute('width', (originalWidth * starFill).toString());
            });
        }
    }

    function getAverageRating(reviews) {
        return getArrayAverage(reviews.map((review) => review.rating)).toFixed(1);
    }

    function getRatingBreakdown(reviews) {
        return reviews.reduce(
            (accumulator, review) => {
                accumulator[review.rating] += 1;
                return accumulator;
            },
            { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 }
        );
    }

    function getArrayAverage(values) {
        if (!values.length) {
            return 0;
        }

        const total = values.reduce((sum, value) => sum + Number(value || 0), 0);
        return total / values.length;
    }

    function normalizeMetricLabel(label) {
        return String(label || '')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, ' ')
            .trim();
    }

    function parseMetricValue(value) {
        const stringValue = String(value || '').trim();
        const match = stringValue.match(/(\d+(?:\.\d+)?)/);

        if (!match) {
            return null;
        }

        const numeric = Number(match[1]);
        if (Number.isNaN(numeric) || numeric > 5) {
            return null;
        }

        return numeric;
    }

    function clampRating(value) {
        const rating = Number(value) || 0;
        return Math.max(1, Math.min(5, Math.round(rating)));
    }

    function formatTimeAgo(dateString) {
        if (!dateString) {
            return '';
        }

        const date = new Date(dateString);
        const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
        const units = [
            ['year', 31536000],
            ['month', 2592000],
            ['week', 604800],
            ['day', 86400],
            ['hour', 3600],
            ['minute', 60]
        ];

        for (const [unit, interval] of units) {
            const amount = Math.floor(seconds / interval);
            if (amount >= 1) {
                return `${amount} ${unit}${amount > 1 ? 's' : ''} ago`;
            }
        }

        return 'just now';
    }

    function formatCount(value, forceStandard = false) {
        return new Intl.NumberFormat('en-US', {
            notation: (!forceStandard && value >= 1000) ? 'compact' : 'standard',
            maximumFractionDigits: (!forceStandard && value >= 1000) ? 1 : 0
        }).format(value).toLowerCase();
    }

    function escapeHtml(value) {
        return String(value || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function escapeAttribute(value) {
        return escapeHtml(value);
    }

    /**
     * Simple async sleep utility for retry backoff.
     * @param {number} ms
     * @returns {Promise<void>}
     */
    function sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
})();
